/**
 * Identifies a SummIT module, for behavior that varies by module (routes, wording, advanced features, etc.).
 * The values are also sent to and received from the back-end as the type of an Issue or Exception, and are displayed in some breadcrumbs.
 */
export enum ProductModule {
    CONTROLS = 'Control Automation',
    TPRM = 'Third-Party Risk Management',
    UCRM = 'AI Governance',
}

/**
 * The modules built on due diligence workflows, whose UI (intake, listings, assessments, folders, issues/exceptions, etc.) is shared by TPRM and UCRM.
 * Use this type to annotate values that cannot be `ProductModule.CONTROLS`, and use `ProductModule.TPRM`/`ProductModule.UCRM` for the values themselves.
 * If `ProductModule.CONTROLS` is a valid value, use `ProductModule` as the type instead.
 */
export type DueDiligenceModule = ProductModule.TPRM | ProductModule.UCRM;
